/* eslint-disable @next/next/no-img-element */
import React, { FunctionComponent } from 'react';

import { Modal } from '../Modal/Modal';

import styles from './DonateToGroupModal.module.scss';
import { Page } from '../../lib/pageData';
import { useFetchGroupMembers } from '../../hooks/useFetchGroupMembers';
import { GroupMembersList } from '../GroupMembersList/GroupMembersList';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '../LoadingButton/LoadingButton';
import { Stack } from '../Stack/Stack';
import { GroupPageSummary } from '../PageSummary/GroupPageSummary';
import { ChevronDown } from '../Icons/ChevronDown';
import classNames from 'classnames';
import { isInMemoryOccasion } from '../../utils/inMemory';

type DonateToGroupModalProps = {
  open: boolean;
  onClose: () => void;
  page: Page;
};

export const DonateToGroupModal: FunctionComponent<DonateToGroupModalProps> = ({
  open,
  onClose,
  page,
}) => {
  const { data, loading, handleFetchMore } = useFetchGroupMembers(page);

  const { t } = useTranslation();
  const isInMemoryTeam = isInMemoryOccasion(page.occasion?.type);
  const members = data?.page?.fundraisers;

  if (!members) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose} className={styles.modal}>
      <Modal.CloseButton />
      <Modal.Body className={styles.modalBody}>
        <Stack className="mb-5" gap="sizeSpacing04">
          <h1 className="cp-heading-medium mb-0 mt-0">
            {t(isInMemoryTeam? 'groupMembersModal.titleInMem' : 'groupMembersModal.title')}
          </h1>
          <GroupPageSummary page={page} t={t} />
        </Stack>
        <Stack className={styles.section}>
          <GroupMembersList
            page={{ ...page, ...data?.page }}
            className={classNames(styles.groupMemberList, {
              [styles.withBorder]: members.pageInfo.hasNextPage,
            })}
          />
          {members.pageInfo.hasNextPage && (
            <LoadingButton
              onClick={handleFetchMore}
              className={classNames('cp-text-link', styles.loadMoreButton)}
              loading={loading}
            >
              {t('groupMembers.loadMoreTeamMembers')}
              <ChevronDown />
            </LoadingButton>
          )}
        </Stack>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <button
          type="button"
          className="cp-btn cp-btn-secondary  "
          onClick={onClose}
        >
          {t('close')}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
